import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs/operators';

import { AuthService } from '../services/auth.service';

/**
 * Protected routes require a usable staff session.
 * A leftover expired access token must not open the shell — refresh or send to login.
 */
export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.token() || !auth.me()) {
    auth.logout();
    return router.createUrlTree(['/auth/login']);
  }

  return auth.ensureValidAccessToken().pipe(
    map((valid) => {
      if (valid) return true;
      auth.handleExpiredSession();
      return router.createUrlTree(['/auth/login']);
    })
  );
};
